import React from 'react'
import PedidosYaStyle from '../../../../../assets/css/components/admin/plugins/PedidosYaStyle'

export default function Navbar(props) {
    const {setCurrentStep, currentStep} = props;

    const changeStep = (v) => {
        setCurrentStep(v)
    }
    return (
        <PedidosYaStyle.ContNavbar>
            <PedidosYaStyle.MenuOptions>
                <PedidosYaStyle.OptionMenu active={currentStep === 1} onClick={() => changeStep(1)}>
                    <div className='d-none d-md-block'>Credenciales de Woocommerce</div>
                    <div className='d-block d-md-none'>Credenciales</div>
                </PedidosYaStyle.OptionMenu>
                <PedidosYaStyle.OptionMenu active={currentStep === 2} onClick={() => changeStep(2)}>
                    Usuarios
                </PedidosYaStyle.OptionMenu>
                <PedidosYaStyle.OptionMenu active={currentStep === 3} onClick={() => changeStep(3)}>
                    <div className='d-none d-md-block'>Productos y Variantes</div>
                    <div className='d-block d-md-none'>Acciones</div>
                </PedidosYaStyle.OptionMenu>
            </PedidosYaStyle.MenuOptions>
        </PedidosYaStyle.ContNavbar>
    )
}
